import { UserReturn } from '../types';
import { axiosInstance } from './base';

export const getUser = async () => {
  const { data } = await axiosInstance.get<UserReturn>('/auth/me');

  // console.log('user:', user);

  if (!data.success) {
    throw new Error(data.code!);
  }

  return data.content;
};
